import { isEmpty } from '@rainbow-modules/validation';
import { WebhookFilterCondition } from '../types';

const normalizeValue = (
    value?: string | WebhookFilterCondition[][],
): WebhookFilterCondition[][] => {
    if (isEmpty(value) || !Array.isArray(value)) return [];
    return value;
};

export default normalizeValue;
